import * as angular from "angular";
import {ServiceAreasServiceType} from "../angular/types/service-areas-service.type";

const events = {
  areaUpdated: 'service-area-updated',
  areaPolygonSelected: 'scroll-to-service-area',
  areaPolygonSelectedFromMap: 'scroll-to-service-area-from-map',
  editPolygon: 'edit-service-area-polygon',
  areaSelected: 'service-area-selected',
  revertServiceAreaChanges: 'revert-service-area-changes'
};

const serviceTypes = [
  ServiceAreasServiceType.Planning,
  ServiceAreasServiceType.Pricing
]

angular
  .module('bringoz.admin.service-areas')
  .constant('ServiceAreaConstants', {
    events: events,
    serviceTypes: serviceTypes
  });
